import actionFe from 'utils/mw/actionFe.util';

const feChangePaymentOption = actionFe('feChangePaymentOption');

// noinspection JSUnusedGlobalSymbols
export default feChangePaymentOption;
